import React from 'react'
import ProjectsSection from '../../sections/Projects/ProjectsSection/ProjectsSection'

const ProjectsPage = () => {
  return (
    <div className='flex justify-center w-full'>
      <ProjectsSection />
    </div>
  )
}

export default ProjectsPage
